import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addLocale(en);

import React, { useEffect, useState } from "react";
import ReactTimeAgo from "react-time-ago";

import TableWrapper from "../tableWrapper/tableWrapper.component";
import useAppContext from "../../../hooks/useAppContext";

import { StyledWrapper } from "./demographicsLayout.style";

const DemographicsLayout = () => {
  const { axios } = useAppContext();
  const [mode, setMode] = useState("sales");
  const [timestamp, setTimestamp] = useState(null);

  const handleClick = (e) => {
    setMode(e.target.name);
  };

  useEffect(() => {
    setTimestamp(null);
    axios
      .get("/admin/solvers/demographics/timestamp", {})
      .then((res) => {
        setTimestamp(res.data.data.timestamp);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [mode]);

  return (
    <StyledWrapper>
      <div className="page-timestamp">
        {timestamp ? (
          <>
            Last updated about <ReactTimeAgo date={timestamp} locale="en-US" />
          </>
        ) : (
          `\u00A0`
        )}
      </div>
      <div className="page-heading">
        <h1>Problem Solver Demographics</h1>
        <div className="page-controls">
          <button
            className={mode == "sales" ? "active disabled" : undefined}
            name="sales"
            onClick={handleClick}
          >
            Sales Data
          </button>
          <button
            className={mode == "admin" ? "active disabled" : undefined}
            name="admin"
            onClick={handleClick}
          >
            Admin Data
          </button>
        </div>
      </div>
      <div className="content-wrapper">
        <div className="content-column">
          <TableWrapper mode={mode} name="demographicsGenders" />
          <TableWrapper mode={mode} name="demographicsAges" />
        </div>
        <div className="content-column">
          <TableWrapper mode={mode} name="demographicsEthnicities" />
          <TableWrapper mode={mode} name="demographicsCountries" />
        </div>
      </div>
    </StyledWrapper>
  );
};

export default DemographicsLayout;
